'use strict'

/**
 * This function opens the delivery method modal
 * @return {string} delivery address data
 */
function getDeliveryAddress() {
    const fulfillmentData = $('.delivery-data').data('fulfillment');
    if (fulfillmentData) {
        const deliveryAddressData = {
            isDeliveryTypeDelivery: fulfillmentData.isShippingMethodDelivery,
            isDeliveryTypeLocker: fulfillmentData.isShippingMethodLocker,
        }

        if (fulfillmentData.address) {
            deliveryAddressData.deliveryAddress = {
                addressName: fulfillmentData.address.name,
                addressDetails: fulfillmentData.address.details
            }
        }
        return deliveryAddressData;
    }

    return {};
}

/**
 * This function opens the delivery method modal
 * @return {boolean} if exists any delivery data
 */
function isDeliveryAddressSet() {
    var deliveryData = getDeliveryAddress();

    if (!deliveryData) {
        return false;
    }

    if (!deliveryData.deliveryAddress || (!deliveryData.isDeliveryTypeDelivery && !deliveryData.isDeliveryTypeLocker)) {
        return false;
    }

    return true;
}

/**
 * This function checks if delivery method is selected
 * @return {boolean} if exists any delivery method
 */
function hasShippingMethod() {
    var ffData = $('.delivery-data').data('fulfillment');
    if (!ffData || (!ffData.isShippingMethodDelivery && !ffData.isShippingMethodLocker)) {
        return false;
    }
    return true;
}
module.exports = {
    getDeliveryAddress: getDeliveryAddress,
    isDeliveryAddressSet: isDeliveryAddressSet,
    hasShippingMethod: hasShippingMethod
};
